import React, { FC, memo } from 'react'
import { NextCardHeadline, Image, NonFlexingContainer } from '@sport1/news-styleguide'

type Props = {
    text: string
    imageUrl?: string
}

const CardHeader: FC<Props> = ({ text, imageUrl }) => {
    return (
        <>
            <NonFlexingContainer marginY={3}>
                <NextCardHeadline text={text} />
            </NonFlexingContainer>
            {imageUrl ? (
                <NonFlexingContainer marginY={3}>
                    <Image aspectRatio="16:9" radiusType="rounded" imageUrl={imageUrl} size="L" />
                </NonFlexingContainer>
            ) : null}
        </>
    )
}

export default memo(CardHeader)
